namespace Areas.Budget.Profile {
    "use strict";

    export function updateProfile() {
            const form = $("#BudgetProfileForm").dxForm("instance");
            const newData: any = form.option("formData");
            const result: any = form.validate();
            const keyId: any = form.option("KeyId");

            if (result.isValid && keyId != null) {
                sendRequest(`/Budget/Profile/Put/${keyId}`, JSON.stringify(newData), "PUT");
            }
        
    }

    export function columnViewLink(cellElement: any, cellInfo: any) {
        buildCellContent(cellElement,
            () => { return cellInfo.data.budgetId; },
            "<a href= '/Budget/Profile/View/{placeholder}'>View</a>");
    }

    export function copyBudget(budgetId: number, accountId: number, accountInfo: string): () => void {
        return () : void => {
            const parameters = { budgetId: budgetId, accountId: accountId, accountInfo: accountInfo };
            const copyBudgetDialog = new Areas.Dialogs.CopyBudgetDialog(() => { }, parameters);
        }
    }

}
